import {useEffect} from 'react'

import Modal from '../../shared/Modal'
import ScopeForm from './ScopeForm'

import {OAUTH} from '../../../state/actionTypes'
import {asyncActions} from '../../../lib/asyncUtil'
import {connect} from '../../../state/hooks/tools'
import {createResource} from '../../../lib/asyncMethods'
import {normalizeResource} from '../../../lib/oauthScopes'

import './newScope.scss'

const NewScope = props => {
  useEffect(() => {
    if (props.showModal)
      props.clearError()
  }, [props.showModal])

  const handleSubmit = ({resource, description}) => {
    props.createResource({
      endpoint: 'oauth-scopes',
      attributes: {resource: normalizeResource(resource), description: description.trim()}
    }).then(response => {
      if (response.success) {
        props.onCreated(response.data.resource)
        props.toggleModal()
      }
    }).catch(props.reportUnreachable)
  }

  return (
    <Modal
      open={props.showModal}
      handleClose={props.toggleModal}
      disabled={props.loading}
      maxWidth='lg'
      buttonText='Cancel'
      subHeading='Name a resource clients can be given access to.'
      title='New Scope'>
      <ScopeForm
        resources={props.scopes.map(scope => scope.resource)}
        permissions={props.permissions}
        error={props.error}
        loading={props.loading}
        handleSubmit={handleSubmit}
      />
    </Modal>
  )
}

const mapStateToProps = ({oauth}) => ({scopes: [], permissions: [], ...oauth})

const actionCreators = ({oauth}) => ({
  createResource: createResource(oauth, OAUTH),
  // the reducer clears the error whenever a request starts, and nothing else clears it
  clearError: () => oauth(asyncActions(OAUTH).loading(false)),
  // a request that never got an answer leaves the browser's own wording behind, such as "Failed to fetch"
  reportUnreachable: () => oauth(asyncActions(OAUTH).failure(true, "We couldn't reach the server. Check your connection and try again."))
})

export default connect(mapStateToProps, actionCreators)(NewScope)
